import { configureStore } from "@reduxjs/toolkit";
import currentUserReducer from "./slices/currentUserSlice";
import accessibleModulesReducer from "./slices/accessibleModulesSlice";

export const store = configureStore({
  reducer: {
    currentUser: currentUserReducer,
    accessibleModules: accessibleModulesReducer,
  },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
